export const GET_ISABI_PERCENTAGES            = 'GET_ISABI_PERCENTAGES';
export const CHANGE_VALUE_FORM_ISABI          = 'CHANGE_VALUE_FORM_ISABI';
export const SAVE_ISABI_PERCENTAGE            = 'SAVE_ISABI_PERCENTAGE';
export const GET_ITEM_ISABI_PERCENTAGE        = 'GET_ITEM_ISABI_PERCENTAGE';
export const DEFAULT_ISABI_DATA               = 'DEFAULT_ISABI_DATA';
export const OPEN_CLOSE_BUDGET_ISABI          = 'OPEN_CLOSE_BUDGET_ISABI';
export const LIST_BUDGETS_ISABI_NOT_CONFIRMED = 'LIST_BUDGETS_ISABI_NOT_CONFIRMED';
export const SELECTED_BUDGET_OPTION           = 'SELECTED_BUDGET_OPTION';
export const SAVE_CONFIRM_PAYMENT_ISABI       = 'SAVE_CONFIRM_PAYMENT_ISABI';
export const LIST_BUDGETS_ISABI_CONFIRMED     = 'LIST_BUDGETS_ISABI_CONFIRMED';
export const GET_ITEM_ISABI_BUDGET            = 'GET_ITEM_ISABI_BUDGET';